export const COMMENT_START_LOADING = "COMMENT_START_LOADING";
export const COMMENT_END_LOADING = "COMMENT_END_LOADING";
export const COMMENT_LOADED = "COMMENT_LOADED";